/* GENERATED — do not edit.
   Source: clients/profit_minded/site_rebuild/_gen_mockups.py COLLECTION_JS
   Regenerate: python clients/profit_minded/theme_variant_a/_derive_assets.py */
/* ===== pm-collection.js — enhancement only ================================
   The sort control is a real GET form with a real submit button, so it works
   with JavaScript disabled. All this does is hide that button and submit on
   change, which is what a shopper expects. It HIDES the button; it never
   removes it, so the no-JS path stays intact in the DOM.
   ========================================================================= */
(function () {
  var form = document.querySelector('[data-pm-sort]');
  if (!form) return;
  var sel = form.querySelector('select[name="sort_by"]');
  if (!sel) return;
  var go = form.querySelector('[data-pm-sort-go]');
  if (go) go.hidden = true;
  sel.addEventListener('change', function () { form.submit(); });
})();
